module.exports = __webpack_public_path__ + "media/images/emblems/Lommiswil-blason-6042000941d4c9c66ea0e0f2a7b09468.png";